import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import LocaleTooling from '../../../../tooling/localeTooling';

const ErrorFeedback = props => {
  const {
    fieldErrors,
    status,
    optionalStatusErrors,
    noErrorStatus,
    conectionErrorStatus,
    localesFieldsPath
  } = props;
  var finalNoErrorStatus = noErrorStatus ?  noErrorStatus : 200;
  var finalConectionErrorStatus = conectionErrorStatus ?  conectionErrorStatus : 500;
  return (status && status!=null && status!==finalNoErrorStatus) ? (
    <div className="info_message error_message">
      {(optionalStatusErrors && status in optionalStatusErrors) ? (
        <div>
          <i className="fas fa-times-circle"/>
          {optionalStatusErrors[status]}
        </div>
      ) : (status == finalConectionErrorStatus) ? (
        <div>
          <i className="fas fa-times-circle"/>
          <FormattedMessage id="common.errors.conectionError"/>
        </div>
      ) : (status == 423) ? (
        <div>
          <i className="fas fa-times-circle"/>
          <FormattedMessage id="common.errors.systemLockedError"/>
        </div>
      ) : (fieldErrors && Object.keys(fieldErrors).length > 0) ? (
        <div>
          {Object.keys(fieldErrors).map((key,index) => {
            return (
              <div key={index}>
                {Array.isArray(fieldErrors[key]) && fieldErrors[key].map((item,i) => (
                  <div className='error_message_line' key={"error" + i}>
                    {localesFieldsPath && (<strong>{LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:localesFieldsPath + "." + key}))}: </strong>)}
                    {item}
                  </div>                   
                ))}
              </div>
            );
          })}
        </div>
      ) : (
        <div>
          <i className="fas fa-times-circle"/>
          <FormattedMessage id="common.errors.genericError"/>
        </div>
      ) }
    </div>
  ) : null;
};

export default ErrorFeedback;



// WEBPACK FOOTER //
// ./source/client/components/common/feedback/errorFeedback.jsx